import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { Subscription } from 'rxjs';
import { ReportsTurnsService } from 'src/app/services/turns-services/reports-turns-service/reports-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-turns-reports-dashboard',
  templateUrl: './turns-reports-dashboard.component.html',
  styleUrls: ['./turns-reports-dashboard.component.scss']
})
export class TurnsReportsDashboardComponent implements OnInit, OnDestroy {

  turnsStatistics;
  totalTurnsAttended;
  totalTurnsBacked;
  totalTurnsPassed;
  totalTurnsAverageSecs;
  totalTurnsPicked;
  totalAppTurnsPicked;
  totalTicketTurnsPicked;
  totalSmsTurnsPicked;
  totalTurnsCancelled;
  totalAppTurnsCancelled;
  totalSmsSent;
  getDailyReportsSubscription: Subscription;

  constructor(private userStorageService: UserStorageService,
    private reportsTurnsService: ReportsTurnsService,
    private headerBreadcrumbService: HeaderBreadcrumbService,
    private snackbarService: SnackBarService) {
    }

  ngOnInit() {
    this.setBreadcrumb();
    this.getDailyReports();
    this.reportsTurnsService.refreshReportsListListen().subscribe(
      (res) => {
        this.turnsStatistics = res['data']['listTurnStadistics'];
        this.totalAppTurnsCancelled = res['data']['totalAppTurnsCancelled'];
        this.totalAppTurnsPicked = res['data']['totalAppTurnsPicked'];
        this.totalSmsTurnsPicked = res['data']['totalSmsTurnsPicked'];
        this.totalTicketTurnsPicked = res['data']['totalTicketTurnsPicked'];
        this.totalTurnsAttended = res['data']['totalTurnsAttended'];
        this.totalTurnsAverageSecs = res['data']['totalTurnsAverageSecs'];
        this.totalTurnsBacked = res['data']['totalTurnsBacked'];
        this.totalTurnsCancelled = res['data']['totalTurnsCancelled'];
        this.totalTurnsPassed = res['data']['totalTurnsPassed'];
        this.totalTurnsPicked = res['data']['totalTurnsPicked'];
        this.totalSmsSent = res['data']['totalSmsSent'];
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'success');
      }
    );
  }

  private getDailyReports() {
    const todayFrom = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime();
    const todayTo = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59.999).getTime();
    const centerInternalIdList = this.userStorageService.getCenterList().map(center => center.InternalId);
    this.getDailyReportsSubscription = this.reportsTurnsService.filterTurnsList(todayFrom, todayTo, centerInternalIdList, ['ACTIVE', 'INACTIVE', 'DELETED'], null).subscribe(
      (res) => {
        this.turnsStatistics = res['data']['listTurnStadistics'];
        this.totalAppTurnsCancelled = res['data']['totalAppTurnsCancelled'];
        this.totalAppTurnsPicked = res['data']['totalAppTurnsPicked'];
        this.totalSmsTurnsPicked = res['data']['totalSmsTurnsPicked'];
        this.totalTicketTurnsPicked = res['data']['totalTicketTurnsPicked'];
        this.totalTurnsAttended = res['data']['totalTurnsAttended'];
        this.totalTurnsAverageSecs = res['data']['totalTurnsAverageSecs'];
        this.totalTurnsBacked = res['data']['totalTurnsBacked'];
        this.totalTurnsCancelled = res['data']['totalTurnsCancelled'];
        this.totalTurnsPassed = res['data']['totalTurnsPassed'];
        this.totalTurnsPicked = res['data']['totalTurnsPicked'];
        this.totalSmsSent = res['data']['totalSmsSent'];
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-file', 'turns-page.turns reports', '/turns', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.turns reports')]));
  }

  ngOnDestroy() {
    if (this.getDailyReportsSubscription) { this.getDailyReportsSubscription.unsubscribe(); }
  }
}
